import { HOST } from "common-import/constants";
import { observable, autorun, computed } from "mobx";
import { Request, MobXHelper, VarHelper } from "common-import/helpers";
const { makePersit } = MobXHelper;
import _ from "lodash";

const LANG_API = HOST + "/languages";

const PERSIST_STORE_ITEM = {
  TYPE_OF_PROJECT: "LANGUAGE_STORE_TYPE_OF_PROJECT"
}

class LanguageStore {
  
  constructor() {
    this.loadInitialData();
  }

  @observable typeOfProject = [];
  @observable phaseOfProject = [];
  @observable statusOfProject = [];
  @observable typeOfConstruction = [];
  @observable typeOfContractor = [];
  @observable typeOfCompany = [];
  @observable typeOfInvestment = [];
  @observable biddingForm = [];

  loadInitialData = async () => {
    let typeOfProject = await makePersit.persist(PERSIST_STORE_ITEM.TYPE_OF_PROJECT, "object");
    if (typeOfProject != undefined) this.typeOfProject = typeOfProject;

    this.getValue("typeOfProject", "DATA_TYPE_OF_PROJECT");
    this.getValue("phaseOfProject", "DATA_PHASE_OF_PROJECT");
    this.getValue("statusOfProject", "DATA_STATUS_OF_PROJECT");
    this.getValue("typeOfConstruction", "DATA_TYPE_OF_CONSTRUCTION");
    this.getValue("typeOfContractor", "DATA_TYPE_OF_CONTRACTOR");
    this.getValue("typeOfCompany", "DATA_TYPE_OF_COMPANY");
    this.getValue("typeOfInvestment", "DATA_TYPE_OF_INVESTMENT");
    this.getValue("biddingForm", "DATA_BIDDING_FORM");
  }
  
  getTypeOfProject = async () => {
    let res = await Request.post(LANG_API, { dataName: "DATA_TYPE_OF_CONTRACTOR", lang: "vi" });
    let json = await res.json();
    if(json.error == null && VarHelper.detectType(json.data) == "array") {
      this.typeOfProject = res.data;
    }
  }

  getValue = async (classProperty, dataName, dataType = "array", lang = "vi" ) => {
    let res = await Request.post(LANG_API, { dataName, lang });
    let json = await res.json();
    if(json.error == null && VarHelper.detectType(json.data) == dataType) {
      this[classProperty] = json.data;
    }
  }
  
}

const languageStore = new LanguageStore();

export default languageStore;


// WEBPACK FOOTER //
// ./src/services/language/Language.Store.js